// Module-scoped flag: the navigation timing entry persists for the document
// lifetime after back/forward restore; consume once so a later client-side
// route to /Login can start OIDC instead of being misclassified as browser back.
let backForwardNavigationConsumed = false;

export function isBackForwardNavigation() {
    if (backForwardNavigationConsumed) {
        return false;
    }
    if (typeof performance === 'undefined' || typeof performance.getEntriesByType !== 'function') {
        return false;
    }
    const [navEntry] = performance.getEntriesByType('navigation');
    return navEntry?.type === 'back_forward';
}

export function consumeBackForwardNavigation() {
    backForwardNavigationConsumed = true;
}

export function isBackForwardPageRestore(event) {
    if (event?.persisted) {
        return true;
    }
    return isBackForwardNavigation();
}

export function shouldReturnToWelcomeFromAbortedLogin(oidcUserData, search = window.location.search) {
    return (
        !hasOidcCallbackParams(search) &&
        (oidcUserData === undefined || oidcUserData === null)
    );
}

export function hasOidcCallbackParams(search = window.location.search) {
    const params = new URLSearchParams(search);
    return params.has('code') || params.has('error');
}

export function clearStaleOidcClientState(storage = window.sessionStorage) {
    Object.keys(storage).forEach((key) => {
        if (key.startsWith('oidc.')) {
            storage.removeItem(key);
        }
    });
}
